import styles from './styles.module.scss';
import { Count as CroplerCount } from '@cropler/ui-kit';

const SidebarTitle = ({ title, count }) => {
  return (
    <h2 className={styles.sidebarTitle}>
      {title}
      {!!count && <CroplerCount>{count}</CroplerCount>}
    </h2>
  );
};

export default SidebarTitle;
